class RatingsManager {
  constructor(data) {
    this.data = data;
    this.ratings = this.getRatings(this.data);
    this.options = this.getOptions(this.data);
    this.totalratings = this.getTotalRatings(this.ratings);
    [this.ratingsPercent, this.averagerating] = this.computeData();
    this.commentSectionData = this.getCommentSectionData(this.options);
    this.apiResponse = this.apiResponse();
  }

  apiResponse() {
    return this.data;
  }

  getRatings(data) {
    return data.ratings;
  }

  getOptions(data) {
    return data.options;
  }

  getTotalRatings(ratings) {
    return Object.values(ratings).reduce((total, num) => total + num, 0);
  }

  computeData() {
    const { ratings } = this.data;
    let total = 0, ratingsPercent = new Array(5).fill(0), denominator = 0, numerator = 0;

    if (this.totalratings) {
      let index = Object.values(ratings).length;
      for (const [key, value] of Object.entries(ratings)) {
        denominator += Number(value);
        numerator += Number(key) * Number(value);

        let val = Math.round((value / this.totalratings) * 100);
        if (total + val > 100) val -= total + val - 100;
        if (index-- === 1 && total + val < 100) val += 100 - (total + val);
        total += val;
        ratingsPercent[Number(key) - 1] = val;
      }
    }
    return [ratingsPercent, numerator ? (numerator / denominator).toFixed(1) : numerator];
  }

  getCommentSectionData(options) {
    return options.slice(0, options.length).map(([catagory, count]) => {
      return {
        employee_count: count,
        category: catagory,
      };
    });
  }
}

export default RatingsManager;
